import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,getKCISData} from '../../services/index';
import { Drawer,message ,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Modal} from 'antd';
import { PlusOutlined,PictureOutlined,VideoCameraOutlined,FileOutlined,CloseOutlined,AudioOutlined } from '@ant-design/icons';

import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import load from '../../assets/images/icon/load.gif';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

const storedFiles=[];
const storedFilespdf=[];
const storedFilesaudio=[];

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			title: '',
			children_id: [],
			program_id: [],
			details: '',
			image: '',
			video: '',
			file: '',
			staff: false,
			loading: false,
  		    iconLoading: false,
  		    Program: false,
  		    Program: false,
  		    is_important: 0,
  		    is_archive: 0,
  		    get_selected_program: [],
  		    program_list: [],
  		    selected_program: [],
  		    school_list: [],
  		    selected_student_data: [],
			mobile_child: false ,
			mobile_class: false ,
			selectedFiles:null,
			previewImage: '',
			previewTitle: '',
			previewVisible: false,
			file_list: [],
			file_list_pdf: [],
			file_list_audio: [],
			dcheckedBoxes: [],
			checkedBoxes: [],
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.goBack = this.goBack.bind(this);
		this.get_selected_program = this.get_selected_program.bind(this);
		this.handleClickProgram = this.handleClickProgram.bind(this);
	}
	
	showDrawerClass = () => {
		this.setState({
		  mobile_class: true,
		});
	  };
	 
	onCloseClass = () => {
		this.setState({
		  mobile_class: false,
		});
	  }; 	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			console.log('auth :',params.s);
			if(params.t!=null && params.s!=null){
				let token = params.t;
				let erp_id = params.s;
				var app = {token:token,erp_id:erp_id}
				getKCISData('auth/verify_token',app).then((result) => {
					let responseJson = result;
					if(responseJson){
						if(result['status'] == 200){
							localStorage.setItem('schoolData',JSON.stringify(responseJson));
							window.location.reload(false);
						}
						else{
							localStorage.setItem("schoolData",'');
							localStorage.clear();
							window.location.href = '/login';
						}
					}
				});
			}
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		this.checkData();
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var type = storedArray['data'][0]['type'];
			 this.setState({ 
			 user_id : storedArray['data'][0]['user_id'], 
			 staff_id : this.props.match.params.id, 
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {user_id : user_id,school_id:school_id,type:type,program_id: this.state.program_id}
			getData('erp/new_program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							program_list: result['data'],
						});
					}else{
						this.setState({
							program_list: [],
						});
					}
				}
			});
			getData('erp/multi_division_list_by_class', app).then((result) => {
                    let responseJson = result;
                    if (responseJson.data) {
                        if (result['status'] == 200) {
                            this.setState({
                                school_list: result['data'],
                            });
                        } else {
                            this.setState({
                                school_list: [],
                            });
                        }
                    }
                });
	}
  }
  
	get_selected_student() {
		var app2 = {
			user_id: this.state.selected_student,
		}
		getData('erp/division_list_selected', app2).then((result) => {
			let responseJson2 = result;
			if (responseJson2.data) {
				if (result['status'] == 200) {
					this.setState({
						selected_student_data: result['data'],
					});
				} else {
					this.setState({
						selected_student_data: [],
					});
				}
			}
		});
	}
  
  get_selected_program(){	 
			var app2 = {user_id : this.state.program_id,}
			getData('erp/program_list_selected',app2).then((result) => {
				let responseJson2 = result;
				if(responseJson2.data){
					if(result['status'] == 200){
						this.setState({
							selected_program: result['data'],
						});
					}else{
						this.setState({
							selected_program: [],
						});
					}
				}
			});	
			setTimeout(() => {
                this.checkData();
            }, 300);
			
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
  
  handleSubmit=(e)=>{
    e.preventDefault();
	if(localStorage.getItem('schoolData')){
	if(this.state.program_id != ''){	
    this.setState({ loading: true });
    document.getElementById('loader').classList.add('d-block');
		var app = {
			user_id: this.state.user_id,
			school_id: this.state.school_id,
			children_id: this.state.children_id,
			program_id: this.state.program_id,
			title: this.state.title,
			is_important: this.state.is_important,
			is_archive: this.state.is_archive,
			details: this.state.details,
			image: this.state.image,
			video: this.state.video,
			file: this.state.file,
		}
      getData('erp/add_noticeboard',app).then((result) => {
      if(result.status==400){
             message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
			document.getElementById('loader').classList.remove('d-block');	
          }
		  if(result.status==200){
				message.config({ top: 150});
			
			const selectedFiles = this.state.file_list;
			const selectedFilespdf = this.state.file_list_pdf;
			const selectedFilesaudio = this.state.file_list_audio;
			const data = new FormData() ;
			
			const image = [] ;
			const pdf = [] ;
			const audio = [] ;
			
			if(selectedFiles.length == 0){
				data.append(`image[0]`, '[]')
			}
			if(selectedFilespdf.length == 0){
				data.append(`pdf[0]`, '[]')
			}
			if(selectedFilesaudio.length == 0){
				data.append(`audio[0]`, '[]')
			}
			
			for (let i = 0; i < selectedFiles.length; i++) {
				data.append(`image[${i}]`, selectedFiles[i].selectedFiles)
			}
			
			for (let i = 0; i < selectedFilespdf.length; i++) {
				data.append(`pdf[${i}]`, selectedFilespdf[i].storedFilespdf)
			}
			
			for (let i = 0; i < selectedFilesaudio.length; i++) {
				data.append(`audio[${i}]`, selectedFilesaudio[i].storedFilesaudio)
			}
			
			data.append('id', result.id);	     
			data.append('type', 'notice_board');	     
			data.append('user_id', this.state.user_id)
			let url = "https://kcisapi.kidzonia.co.in/v1/erp/update_attached_file";
			axios.post(url, data, {
			})
			.then(res => {
				this.setState({ loading: true });
				   message.config({ top: 150});
				   message.success('Notice Board added',2);
				   this.setState({ loading: false });
				   window.location.reload(false);				
				document.getElementById('loader').classList.remove('d-block');	
			})

          }
      });
	   }else{
		message.error('Please Select Program',2);	
		document.getElementById('loader').classList.remove('d-block');	
	  }
	  }else{
		message.error('Please Login',2);	
		document.getElementById('loader').classList.remove('d-block');	
	  }

  }
  
  
  
  handleClickProgram(event) {
        const target = event.target;
        var value = target.value;
		console.log(value);
        if(target.checked){
            this.state.selected_program[value] = value;   
            this.state.program_id[value] = value;   
        }else{
            this.state.selected_program.splice(value, 1);
            this.state.program_id.splice(value, 1);
        }
       console.log(this.state.selected_program);
		//this.checkData();
    }
	
	showModalProgram = () => {
		this.setState({
		  Program: true,
		});
	};
	
	showModal = () => {
            this.setState({
                staff: true,
            });
    };
    handleOk = e => {
		this.get_selected_student();
		console.log(e);
		this.setState({
			child: false,
			staff: false,
			mobile_child: false,
		});
    };
    handleCancel = e => {
		this.setState({
			child: false,
			staff: false,
		});
	};

	handleOkProgram = e => {
    this.get_selected_program();
    console.log(e);
    this.setState({
      Program: false,
      mobile_class: false,
    });
  };

  handleCancelProgram = e => {
    console.log(e);
    this.setState({
      Program: false,
    });
  };

  handleChange = ({ fileList }) => this.setState({ fileList });
  
  handleFileSelect = (e) =>{
		var files = e.target.files;		
		
		var people = [];
	
		
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function (f) {   
	
			if (storedFiles.length > 3) {
				message.config({ top: 150});
				message.error('Sorry!..You can upload maximum 10 files at a time',2);
			} else {
				var _size = f.size;
				if (_size > 4100000) {
					message.config({ top: 150});
					message.error("Sorry!..You Can't Upload more then 4MB!",2);
					return false;
				}
				
				var reader = new FileReader();
				reader.onload = function (e) {
					var name = f.type;
					var t = name.toString().split('/');
					//if (t[0] === 'image') {
						var app = {
							file_name: f.name,
							file_url: e.target.result,					
							file_type: 'image',
							selectedFiles: f
						}
						storedFiles.push(app);
						people.push(f);
					// }				
				}
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({file_list:storedFiles});
		}, 500);
	} 

	removeFile= (file,e) =>{
		for (var i = 0; i < storedFiles.length; i++) {
			if (storedFiles[i].file_name === file) {
				storedFiles.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {			
			if (storedFiles.length=='0') {
				const file = document.querySelector('.file');
				file.value = '';
			}			
			this.setState({file_list:storedFiles});
			//console.log(storedFiles);
		}, 500);
	}
	
	handleFileSelectpdf = (e) =>{
		var files = e.target.files;		
		
		var people = [];
	
		
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function (f) {   
	
			if (storedFilespdf.length > 3) {
				message.config({ top: 150});
				message.error('Sorry!..You can upload maximum 10 files at a time',2);
			} else {
				var _size = f.size;
				if (_size > 4100000) {
					message.config({ top: 150});
					message.error("Sorry!..You Can't Upload more then 4MB!",2);
					return false;
				}
				
				var reader = new FileReader();
				reader.onload = function (e) {
					var name = f.type;
					var t = name.toString().split('/');
					//if (t[0] === 'image') {
						var app = {
							file_name: f.name,
							file_url: e.target.result,					
							file_type: 'pdf',
							storedFilespdf: f
						}
						storedFilespdf.push(app);
						people.push(f);
					// }				
				}
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({file_list_pdf:storedFilespdf});
		}, 500);
	} 

	removeFilepdf = (file,e) =>{
		for (var i = 0; i < storedFilespdf.length; i++) {
			if (storedFilespdf[i].file_name === file) {
				storedFilespdf.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {			
			if (storedFilespdf.length=='0') {
				const file = document.querySelector('.file');
				file.value = '';
			}			
			this.setState({file_list_pdf:storedFilespdf});
			//console.log(storedFilespdf);
		}, 500);
	}
	
	handleFileSelectaudio = (e) =>{
		var files = e.target.files;		
		
		var people = [];
	
		
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function (f) {   
	
			if (storedFilesaudio.length > 3) {
				message.config({ top: 150});
				message.error('Sorry!..You can upload maximum 10 files at a time',2);
			} else {
				var _size = f.size;
				if (_size > 4100000) {
					message.config({ top: 150});
					message.error("Sorry!..You Can't Upload more then 4MB!",2);
					return false;
				}
				
				var reader = new FileReader();
				reader.onload = function (e) {
					var name = f.type;
					var t = name.toString().split('/');
					//if (t[0] === 'image') {
						var app = {
							file_name: f.name,
							file_url: e.target.result,					
							file_type: 'pdf',
							storedFilesaudio: f
						}
						storedFilesaudio.push(app);
						people.push(f);
					// }				
				}
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({file_list_audio:storedFilesaudio});
		}, 500);
	} 

	removeFileaudio = (file,e) =>{
		for (var i = 0; i < storedFilesaudio.length; i++) {
			if (storedFilesaudio[i].file_name === file) {
				storedFilesaudio.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {			
			if (storedFilesaudio.length=='0') {
				const file = document.querySelector('.file');
				file.value = '';
			}			
			this.setState({file_list_audio:storedFilesaudio});
			//console.log(storedFilesaudio);
		}, 500);
	}
	
	toggleChecked = () => {
            const checkedBoxes = [...this.state.checkedBoxes];
            var checkboxes = document.getElementsByName('checked_id[]');
            for (var i = 0; i < checkboxes.length; i++) {
                checkedBoxes.push(checkboxes[i].value);
            }
            this.setState({
                checkedBoxes,
                checked: true,
                selection_count: checkedBoxes.length,
                selected_student: checkedBoxes,
                children_id: checkedBoxes
            });
            console.log(checkedBoxes);
        }
        toggleUnChecked = () => {
            const checkedBoxes = [...this.state.checkedBoxes];
            this.setState({
                checkedBoxes: [],
                checked: false,
                selection_count: 0,
                selected_student: [],
                children_id: []
            });
        }
        handleCheckbox = (e, s) => {
            const checkedBoxes = [...this.state.checkedBoxes];
            if (e.target.checked) {
                checkedBoxes.push(s)
            } else {
                const index = checkedBoxes.findIndex((ch) => ch === s);
                checkedBoxes.splice(index, 1);
            }
            this.setState({
                checkedBoxes,
                selection_count: checkedBoxes.length,
                selected_student: checkedBoxes,
                children_id: checkedBoxes
            });
        }
	
	dtoggleChecked = () => {		
		const dcheckedBoxes = [...this.state.dcheckedBoxes];
		var checkboxes = document.getElementsByName('class_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			dcheckedBoxes.push(checkboxes[i].value);	
		}
		this.setState({program_id:dcheckedBoxes,dcheckedBoxes,dchecked:true,dselection_count:dcheckedBoxes.length,selected_class:dcheckedBoxes,class_id:dcheckedBoxes});
    }
	 
	dtoggleUnChecked = () => {		
		const dcheckedBoxes = [...this.state.dcheckedBoxes];
		this.setState({dcheckedBoxes:[],program_id:[],dchecked:false,dselection_count:0,selected_class:[],class_id:[]});
    }
	
	dhandleCheckbox = (e, s) => {
	
		const dcheckedBoxes = [...this.state.dcheckedBoxes];
		if(e.target.checked) {
			dcheckedBoxes.push(s)
		} else {
			const index = dcheckedBoxes.findIndex((ch) => ch === s);
			dcheckedBoxes.splice(index, 1);
		}
		console.log('program_id: ',dcheckedBoxes);
		this.setState({program_id:dcheckedBoxes,dcheckedBoxes,dselection_count:dcheckedBoxes.length,selected_class:dcheckedBoxes,class_id:dcheckedBoxes});
	}
	
  
  
  goBack(){
		window.location.href = '/notice-board/index';
	}
	

	render()

	{
	
	const { size } = this.state;
	const content = (
					 <div>
						<p className="center upload-img">
							<Tooltip placement="right" title="Pdf">
								<label tabindex="0" class="pointer" role="button" for="pdf">
									<img src={pdf_} className="pointer"/>
									<input  onChange={this.handleFileSelectpdf} class="file-upload__input file hide" type="file" name="files" id="pdf" accept=".pdf" multiple="multiple" style={{display: 'none',opacity: '0'}}/> 
								</label>
							</Tooltip>
						</p>
						<p className="center upload-img">
							<Tooltip placement="right" title="Image">
								<label tabindex="0" class="pointer" role="button" for="image">
									<img src={image} className="pointer"/>
									<input  onChange={this.handleFileSelect} class="file-upload__input file hide" type="file" name="files" id="image" accept="image/*" multiple="multiple" style={{display: 'none',opacity: '0'}}/> 
								</label>
							</Tooltip>
						</p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i>Add Notice

								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/notice-board/index`} class="router-link-active" target="_self">Manage Notice Board</a></li>
										<li class="breadcrumb-item"> Add Notice</li>

									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			
			
			<div id="main" class="bg-off">
         <div class="row">
            
			<div class="col s12 m12 ex-padd">
            <div class=" ">
			   <div class="col s12 m12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food">
					
					<div class="div-loader" id="loader">
						<img src={load} /> File Uploading Please Wait !!!
					</div>
				 
					<div class="desktop-view">
						<div class=" children  bg-color-1 mb-20 iq-card2">
							 <Collapse defaultActiveKey={['1']} onChange={callback}>
								<Panel header="Programs" classname="as" key="1">
									<Button className="snd-btn" onClick={this.showModalProgram}> Select Program</Button>
									
									 <div class="children bg-blue attendance">
									  <Checkbox.Group  name="children_id[]" >
										{this.state.selected_program.map((list) => (
											   <Checkbox value={list.id} id={list.id} defaultChecked={true} disabled><label class="w-100" for={list.id} >
											   <div class="center">{list.name} </div>
											   </label>
											   </Checkbox>
											))} 
										</Checkbox.Group>
									</div>											
										   
									
									 <Modal
									  title="Select Program"
									  visible={this.state.Program}
									  onOk={this.handleOkProgram}
									  onCancel={this.handleCancelProgram}
									  className="notice-board"
									>
									  <div class="children bg-blue attendance">
										  <div class="col-md-12">
										{(() => {
											if (this.state.dchecked==true) {
												return (
													<>
													<Checkbox  
														onClick={this.dtoggleUnChecked.bind(this)}
														checked="checked"
														id="alls"
													>
													<label for="alls" className="select-all">UNSELECT All </label>
													</Checkbox>
													</>
												)
											}
											else{
												return (
													<>
													<Checkbox  
														onClick={this.dtoggleChecked.bind(this)}
														checked=""
														id="alls"
													>
													<label for="alls" className="select-all">SELECT All </label>
													</Checkbox>
													</>
												)
											}
										})()}
									</div>
							
											
										<div class="row">
										{this.state.program_list.map((list) => (
											<div class="col m3 s6 d-contents mob-d-block">
											   <Checkbox  
												name="class_id[]"
												value={list.id}
												id={`prog_${list.id}`}
												checked={this.state.dcheckedBoxes.find((ch) => ch === list.id)}
												onChange={(e) => this.dhandleCheckbox(e, list.id)}
												>
												<label for={`prog_${list.id}`} className="checked">
												   <div class="center">{list.name}</div>
												</label>
											   </Checkbox>
										   </div>
										))}   
									</div>
									</div>
									</Modal>
									
								</Panel>
							  </Collapse>
						</div> 
						<div class="children mb-20 iq-card2">
                           <Collapse defaultActiveKey={['1']} onChange={callback}>
                              <Panel header="Division" classname="as" key="1">
                                 <Button className="snd-btn" onClick={this.showModal}>Select Division</Button>
                                 <div class="children bg-blue attendance">
                                    <Checkbox.Group  name="children_id[]" >
                                       {this.state.selected_student_data.map((list) => (
                                       <Checkbox value={list.id} id={list.id} defaultChecked={true} disabled>
                                          <label class="w-m" for={list.id} >
                                             <div class="center">
                                                 {list.name}
                                             </div>
                                          </label>
                                       </Checkbox>
                                       ))}   
                                    </Checkbox.Group>
                                 </div>
                                 <Modal
                                    title="Select Division"
                                    visible={this.state.staff}
                                    onOk={this.handleOk}
                                    onCancel={this.handleCancel}
                                    className="children-model"
                                    >
                                    <div class="children bg-blue attendance">
                                       <div class="col-md-12">
                                          {(() => {
                                          if (this.state.checked==true) {
                                          return (
                                          <>
                                          <Checkbox  
                                             onClick={this.toggleUnChecked.bind(this)}
                                             checked="checked"
                                             id="all"
                                             >
                                             <label for="all" className="select-all">UNSELECT All </label>
                                          </Checkbox>
                                          </>
                                          )
                                          }
                                          else{
                                          return (
                                          <>
                                          <Checkbox  
                                             onClick={this.toggleChecked.bind(this)}
                                             checked=""
                                             id="all"
                                             >
                                             <label for="all" className="select-all">SELECT All </label>
                                          </Checkbox>
                                          </>
                                          )
                                          }
                                          })()}
                                       </div>
                                       <div class="row">
                                          {this.state.school_list.map((list) => (
                                          <div class="col m3 s6 d-contents mob-d-block">
                                             <Checkbox  
                                                name="checked_id[]"
                                                value={list.id}
                                                id={`child_${list.id}`}
                                                checked={this.state.checkedBoxes.find((ch) =>
                                                ch === list.id)}
                                                onChange={(e) => this.handleCheckbox(e, list.id)}
                                                >
                                                <label for={`child_${list.id}`} className="checked">
                                                   <div class="center">
                                                     {list.name}
                                                   </div>
                                                </label>
                                             </Checkbox>
                                          </div>
                                          ))}   
                                       </div>
                                    </div>
                                 </Modal>
                              </Panel>
                           </Collapse>
                        </div>
					</div> 
					
					
					
					
					
					
					 
					
						<div class="row">
						<div class="col-md-12">
							<input type="text" class="" name="title" onChange={this.handleSizeChange}  placeholder="Title Of Notice*" />
						</div>
						</div>
						<div class="col-md-12 mt-20">
                        <div class="meal mt-10 mb-20 pb-20">
                           <div class="row">
                              <div class="col-md-10 col-sm-9 col-xs-9 no-padd">
                                 <TextArea
                                 placeholder="Enter Details Here !!"
                                 autoSize={{ minRows: 2, maxRows: 6 }}
                                 onChange={this.handleSizeChange} 
                                 name="details"
                                 id="details"
                                 />
                              </div>
                              <div class="col-md-2 col-sm-3 col-xs-3 desktop-view">
                                 <Popover content={content} trigger="click">
                                    <img src={attached} class="" alt="image" />
                                 </Popover>
                              </div>
                           </div>
                        </div>
                     </div>
						<div class="mb-20 pb-20 bb photos d-flow-root">
						<div class="upload-gallery " id="img_view">
											<div class="col m12 s12">
												{this.state.file_list.map((img) => (
												<>
												{(() => {
												  return (
								
														<div class="ant-upload-list ant-upload-list-picture-card">
														<div class="ant-upload-list-item ant-upload-list-item-done">
														   <div class="ant-upload-list-item-info">
														  
																
																{/* <label>{img.file_name}</label>	*/}
															<ModalImage  small={img.file_url} large={img.file_url} hideDownload="true" />
															  <button class="remove" id='remove' data-file={img.file_name} onClick={this.removeFile.bind(this,img.file_name)} type='button' title='Remove'><CloseOutlined /></button>									

														</div>
														</div>
														</div>
												)						
												
												})()}
												</>
												))}
												</div>
												<div class="col m12 s12">
												{this.state.file_list_pdf.map((img) => (
												<>
												{(() => {
												  return (
								
														<div class="ant-upload-list ant-upload-list-picture-card pdf">
														<div class="ant-upload-list-item ant-upload-list-item-done">
														   <div class="ant-upload-list-item-info">
														  
																
															<label>{img.file_name}</label>	
															
															  <button class="remove" id='remove' data-file={img.file_name} onClick={this.removeFilepdf.bind(this,img.file_name)} type='button' title='Remove'><CloseOutlined /></button>									

														</div>
														</div>
														</div>
												)						
												
												})()}
												</>
												))}
												</div>
												<div class="col m12 s12">
												{this.state.file_list_audio.map((img) => (
												<>
												{(() => {
												  return (
								
														<div class="ant-upload-list ant-upload-list-picture-card pdf">
														<div class="ant-upload-list-item ant-upload-list-item-done">
														   <div class="ant-upload-list-item-info">
														  
																
															<label>{img.file_name}</label>	
															
															  <button class="remove" id='remove' data-file={img.file_name} onClick={this.removeFileaudio.bind(this,img.file_name)} type='button' title='Remove'><CloseOutlined /></button>									

														</div>
														</div>
														</div>
												)						
												
												})()}
												</>
												))}
												</div>
							</div>
						</div>
					
					<div class="col m12 s12 meal mb-20 center">
						 <Button className="ant-btn btn btn-secondry mr-2 mobile-hide" onClick={this.goBack}>Back</Button>
                        <Button className="ant-btn btn  btn-primary mr-2" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
         </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
